export default {
    Menu: 'Menu',
    Add: 'Ajouter',
    Modify: 'Modifier',
    Delete: 'Supprimer',
    Color: 'Couleur',
    Materials: 'Matériaux',
    Mesh: 'Maillage',
    Size: 'Taille',
    Details: 'Détails',
    Quantity: 'Quantité',
    AddToCart: 'Ajouter au panier',
    Cart: 'Panier',
    Total: 'Total',
    Subtotal: 'Sous-total',
    Shipping: 'Livraison',
    LeaveConfirm: 'Êtes-vous sûr de vouloir perdre vos modifications ?',
    Products: 'Produits',
    Customization: 'Personnalisation',
    ChooseCategory: 'Choisissez une catégorie',
    SelectProduct: 'Choisissez un produit',
    Loading: 'Chargement',
    ValidationInProgress: 'Validation de votre création',
    ValidationLoadingMessage:
        'Nous validons votre création, et l\'ajoutons à votre panier, cela va prendre moins d\'une minute. Merci de votre patience.',
    LoadingScene: 'Chargement de la scène',
    LoadingProduct: 'Chargement du produit',
    Category: 'Catégorie',
    Product: 'Produit',
    Summary: 'Sommaire',
    SelectZone: 'Sélectionner une zone',
    Undo: 'Annuler',
    Redo: 'Rétablir',
    Save: 'Enregistrer',
    Saving: 'Enregistrement',
    Grid: 'Grille',
    SwitchTo3D: 'Passer en 3D',
    ShowZoneBorders: 'Afficher le contour des zones',
    ShowZoneBorderSingular: 'Afficher le contour de la zone',
    ShowZoneBordersHelp: 'Affiche/masque le contour pointillé et le libellé des zones sur le canvas 2D.',
    ManageElements: 'Gérer les éléments',
    StartWithTheme: 'Partir d\'un thème',
    Customize: 'Personnaliser',
    FromThemeLibrary: 'Depuis notre bibliotheque de thème',
    StartFromScratch: 'Partir de zéro',
    Or: 'ou',
    PreviousCreations: 'Créations précédentes',
    WithModel: 'Avec un modèle',
    Search: 'Rechercher',
    SubCategory: 'Sous-catégorie',
    Next: 'Suivant',
    Previous: 'Précédent',
    Validate: 'Valider',
    EditThemeColors: 'Modifier les couleurs des éléments',
    AddPattern: 'Ajouter un motif',
    EditGraduation: 'Modifier la graduation',
    Pattern: 'Motif',
    Graduation: 'Graduation',
    Graduation_s: 'Graduation(s)',
    ErrorOccurred: 'Une erreur est survenue.',
    ReloadPage: 'Veuillez recharger votre page.',
    LoadingCategories: 'Chargement des catégories',
    LoadingThemes: 'Chargement des thèmes',
    LoadingPatterns: 'Chargement des motifs',
    EditableThemeColors: 'Couleurs modifiables des éléments',
    PickAColor: 'Choisissez une couleur',
    SelectALayout: 'Sélectionnez un modèle',
    CreateLayer: 'Créer un élément',
    LastDownloads: 'Derniers téléchargements',
    Cancel: 'Annuler',
    Back: 'Précédent',
    BackToProvider: 'Retour sur {provider}',
    LayerNotFound: 'L\'élément n\'a pas été trouvé',
    ChangeImage: 'Changer l\'image',
    ChangePattern: 'Changer le motif',
    Resize: 'Redimensionner',
    AddFilter: 'Ajouter un filtre',
    PhotoCredit: 'Photo de {author} sur {provider}',
    PhotoBy: 'Photo de',
    On: 'sur',
    LinkRedirectionWarning: 'Ce lien vous redirigera vers ce site internet',
    LoadMore: 'Charger plus',
    EditLayer: 'Editer l\'élément',
    Import: 'Importer',
    FromYourDevice: 'Depuis votre appareil',
    FromImageGallery: 'Depuis la galerie d\'images',
    NoGraduationsAvailable: 'Aucune graduation disponible',
    Confirm: 'Confirmer',
    CustomizeProduct: 'Personnalisez votre produit',
    WriteYourText: 'Écrivez votre texte ici',
    Text: 'Texte',
    Image: 'Image',
    DesignSummary: 'Récapitulatif de votre design',
    AddOptions: 'Ajouter des options',
    TermsOfSale: 'Conditions genérales de vente',
    TOSMessage:
        'Je certifie que ma création est conforme aux [Conditions genérales de vente](#) et en particulier à l\'article 8- Propriété intellectuelle',
    IValidateMyCreation: 'Je valide ma création',
    FunctionalityNotAvailable: 'Fonctionnalité non disponible',
    Lock: 'Verrouiller',
    Unlock: 'Déverouiller',
    AddLayer: 'Ajouter un élément',
    PleaseAgreeTOS: 'Veuillez accepter les conditions générales pour valider votre création.',
    ErrorExportPrintFile: 'Une erreur s\'est produite lors de l\'export du fichier d\'impression.',
    ErrorExportProofFile: 'Une erreur s\'est produite lors de l\'export du bon à tirer.',
    ErrorAddToCart: 'Une erreur s\'est produite lors de l\'ajout au panier: ',
    Gabarit: 'Gabarit',
    FicheTechnique: 'Fiche technique',
    GeneratingPrintFile: 'Génération du fichier d\'impression...',
    GeneratingProofFile: 'Génération du bon à tirer...',
    LeaveCustomizer: 'Quitter le configurateur',
    LeaveManager: 'Quitter le gestionnaire des éléments',
    Duplicate: 'Dupliquer',
    LoadingTheme: 'Chargement du thème',
    LoadingPattern: 'Chargement du motif',
    Expand: 'Agrandir',
    Shrink: 'Rétrécir',
    TiltLeft: 'Incliner à gauche',
    TiltRight: 'Incliner à droite',
    Move: 'Déplacer',
    NoCustomization: 'Il n\'y a pas de personnalisation sur le produit.',
    MissingCustomization: 'Personnalisation manquante',
    SelectGraduation: 'Sélectionnez une graduation',
    ProofTitle: 'Bon à tirer',
    ProofDesignTitle: 'Personnalisation 2D',
    ProofScreenshotsTitle: 'Rendus 3D',
    Warning: 'Attention',
    SelectZoneBeforeTheme: 'Veuillez selectionner une zone avant de choisir un theme.',
    ThemeTooManyElements: 'Le thème contient trop d\'éléments. Merci d\'en choisir un autre',
    Error: 'Erreur',
    ProductNotFound: 'Produit introuvable',
    ProductNotFoundMessage: 'Produit introuvable, vous allez être redirigé vers la page d\'accueil.',
    NoCategoryAvailable: 'Aucune catégorie disponible',
    CategoryNotFound: 'Catégorie introuvable',
    CategoryNotFoundMessage: 'Catégorie introuvable, vous allez être redirigé vers la page d\'accueil.',
    Unavailable: 'Indisponible',
    // Saved Configurations
    SavedConfigurations: 'Configurations sauvegardées',
    YourSavedConfigurations: 'Vos configurations sauvegardées',
    NoSavedConfigurations: 'Aucune configuration sauvegardée pour ce produit',
    ConfigurationName: 'Nom de la configuration',
    Created: 'Créé',
    Expires: 'Expire',
    Load: 'Charger',
    ConfirmDeleteConfiguration: 'Êtes-vous sûr de vouloir supprimer cette configuration ?',
    Preview: 'Aperçu',
    Close: 'Fermer',
    '': ''
};
